var _path, _path2, _path3, _path4, _circle, _circle2, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3H11C9.89543 3 9 3.89543 9 5V19",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3H23",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7L23 7",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11L23 11",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 19,
    r: 2,
    fill: "#F0F0F0",
    stroke: "black",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 19,
    r: 2,
    fill: "#F0F0F0",
    stroke: "black",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.98516 9.21913C5.22238 8.92261 5.58152 8.75 5.96125 8.75H9C9.41421 8.75 9.75 8.41421 9.75 8C9.75 7.58579 9.41421 7.25 9 7.25H5.96125C5.12584 7.25 4.33573 7.62975 3.81386 8.28209L0.852611 11.9837C0.462522 12.4713 0.25 13.0771 0.25 13.7016V17C0.25 18.5188 1.48122 19.75 3 19.75H3.14538C3.05163 19.5184 3 19.2652 3 19C3 18.7348 3.05163 18.4816 3.14538 18.25H3C2.30964 18.25 1.75 17.6904 1.75 17V13.7016C1.75 13.4177 1.8466 13.1423 2.02391 12.9207L4.98516 9.21913ZM6.85462 18.25C6.94837 18.4816 7 18.7348 7 19C7 19.2652 6.94837 19.5184 6.85462 19.75H16.1454C16.0516 19.5184 16 19.2652 16 19C16 18.7348 16.0516 18.4816 16.1454 18.25H6.85462ZM19.8546 18.25C19.9484 18.4816 20 18.7348 20 19C20 19.2652 19.9484 19.5184 19.8546 19.75H21C22.5188 19.75 23.75 18.5188 23.75 17V15C23.75 14.5858 23.4142 14.25 23 14.25C22.5858 14.25 22.25 14.5858 22.25 15V17C22.25 17.6904 21.6904 18.25 21 18.25H19.8546Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarIcon);
export default __webpack_public_path__ + "static/media/car_icon.838b05704b8c6bca2915b82bc11adcd7.svg";
export { ForwardRef as ReactComponent };